import React from 'react';
import { SettingsWrapperProps } from './types';
import { LayoutSidebar } from '../sidebar/LayoutSidebar';

export const SettingsWrapper: React.FC<SettingsWrapperProps> = ({ children }) => (
  <LayoutSidebar>
    <div className='w-full h-full flex-1 flex gap-20 xl:gap-32'>
      <div className='flex-1 overflow-x-auto'>{children}</div>
    </div>
  </LayoutSidebar>
);
